require('../scss/page-catalog.scss');
require('../fonts/Monly/face.css');
/* ------------------------------------------------------------------------- */

let getProducts = require('./parts/products.js');

let F = (function () {
    let catalog_base = $('[data-catalog-base]').data('catalog-base');
    if (!catalog_base) return ;

    let products = getProducts();

    products = products.filter(function (p) {
        var userRegistered = $('[data-user-reg]').data('user-reg');
        if(!userRegistered && p.season.indexOf('Лето 2024')>=0){
            return false; // прячем сезон лето 2024 от незарегистрированных
        }
        return true;
    });

    let current_state = location.href;
    let params = {};

    // console.log(products);

    /* ------------------------------------------------------------ */

    let last_search_value = '';
    let genders = ['obuv-dlya-malchikov', 'obuv-dlya-devochek'];

    function do_search(el){
        let str = $('[data-product-search]').val().toLowerCase();
        if(el){
            str = $(el).val().toLowerCase();
        }
        //let str = $(this).val().toLowerCase();
        console.log('> Search: ' + str);
        // if (str === '' && last_search_value === '') return;
        // if (last_search_value === str) return;
        last_search_value = str;

        let filtred = [];

        products.map(function (p) {
            let find_in = [p.search, p.art, p.brand, p.color, p.name, p.type, p.price, p.price_].join('|').toLowerCase();
            let t1 = Translit.IN(str);
            let t2 = Translit.OUT(str);
            if (find_in.indexOf(str) == -1 && find_in.indexOf(t1) == -1 && find_in.indexOf(t2) == -1) return ;
            filtred.push(p);
        });

        console.log('display 3 отфильтровано товаров: '+filtred.length);
        display(filtred); //3
    }

    function do_search_str(str){
        str = str.toLowerCase();
        console.log('> Search: ' + str);
        if (str === '' && last_search_value === '') return;
        if (last_search_value === str) return;
        last_search_value = str;

        let filtred = [];

        products.map(function (p) {
            let find_in = [p.search, p.art, p.brand, p.color, p.name, p.type, p.price, p.price_].join('|').toLowerCase();
            let t1 = Translit.IN(str);
            let t2 = Translit.OUT(str);
            if (find_in.indexOf(str) == -1 && find_in.indexOf(t1) == -1 && find_in.indexOf(t2) == -1) return ;
            filtred.push(p);
        });

        console.log('display 2 отфильтровано товаров: '+filtred.length);
        display(filtred); //2
    }

    emitter.on('startSearch',data=>{
        let str = data.toLowerCase();
        $('[data-product-search]').val(str); // прокидываем на оба input, мобильный и десктопный
        if($('body').hasClass('catalog-page')){
            // если на странице каталога - ищем
            console.log('> Search: на странице каталога');
            do_search();
        }
    });

    $(document).on('keyup change', '[data-product-search]', function () {
        let str = $(this).val().toLowerCase();
        $('[data-product-search]').val(str); // прокидываем на оба input, мобильный и десктопный

        if($('body').hasClass('catalog-page')){
            // если на странице каталога - ищем
            console.log('> Search: на странице каталога');
            do_search(this);
        }else{
            // если не на странице каталога - переходим
            // let str = $('[data-product-search]').val().toLowerCase();
            // alert("/katalog?find="+str);
            // window.location.href = "/katalog?find="+str;
        }
    });

    $('[data-mobile-search]').show();

    /* ------------------------------------------------------------ */

    let clear = {
        'sort' : function () {
            $('[data-checkbox="sort"] [data-val]').removeClass('active');
            $('[data-checkbox="sort"] .variant.default').addClass('active');
        },
        'pop-filter' : function () {
            $('#pop-filter-text').html("Популярные товары:");
            $('[data-checkbox="pop-filter"] [data-val]').removeClass('active');

            $('.top-banner1').html('<a href="/sami-proizvodim-obuv"><img class="img1" src="/media/banners/top/2020-05-11/IMG_4515.PNG"></a>');
            // $('.top-banner2').html('<a href="/usloviya-dostavki"><img class="img1" src="/media/banners/top/2020-05-11/IMG_4514.PNG"></a>');

            //html2url('from clear pop-filter'); //from clear pop-filter

            //alert('очистка');
            //debugger;
        },
        'price' : function () {
            $('[data-to]').val($('[data-from]').attr('max')).trigger('change');
            $('[data-from]').val(0).trigger('change');
            $('[data-checkmax], [data-checkbox="mark"] [data-val]').removeClass('active');
        },
        'size' : function () {
            $('[data-checkbox="size"] [data-val]').removeClass('active');
        },
        'features' : function () {
            console.log('clear features');
            $('[data-checkbox="features"] [data-val]').removeClass('active');
        },
        'type' : function () {
            console.log('clear type');
            $('[data-type-selector] [data-val]').removeClass('active');
        },
        'gender' : function () {
            $('[data-checkbox="gender"] [data-val]').removeClass('active');
        },
    };

    let closeTypeMobile = function(){
        $('.type-target.opened').removeClass('opened');
        $('.type-opened').removeClass('type-opened');
    };
    let closeFiltersMobile = function(){
        $('.type-target .opened, .filter.filter-target').removeClass('opened');
        $('.filter-opened').removeClass('filter-opened');
    };

    $('[data-open-catalog=".filter-target"]').click(closeTypeMobile);
    $('[data-open-catalog=".type-target"]').click(closeFiltersMobile);

    // [F:] Clear Type
    $('[data-clear="m-type"]').click(function(){
        $('[data-type-selector] [data-val]').removeClass('active');
        closeTypeMobile();
        html2url('from clear data-clear="m-type"'); // from clear data-clear="m-type"
    });

    // [F:] All Filters
    $('[data-clear="m-filters"]').click(function(){
        // нажали очистку фильтров на мобильной версии
        closeFiltersMobile();
        $('[data-checkbox="gender"] [data-val]').removeClass('active');
        $('[data-checkbox] [data-val]').removeClass('active');
        $('[data-type-selector] [data-val]').removeClass('active');
        for (let nm in clear) clear[nm]();
        //closeFiltersMobile();
        //html2url();
        html2urlAction(false,'from data-clear="m-filters"');
        window.need_url2html=true;
    });

    // [F:] Clear All
    $('[data-clear="all"]').click(function(){
        $('[data-checkbox] [data-val]').removeClass('active');
        $('[data-type-selector] [data-val]').removeClass('active');
        clear.price();
        clear["pop-filter"]();

        emitter.emit('startSearch','');

        //todotodo
        setTopFilters();

        //html2url();
        html2urlAction(false,'from data-clear="all"');
    });

    // [F:] Submit filters
    $('[data-submit="all"]').click(function(){
        html2urlAction(false, 'from data-submit="all"');
    });
    $('[data-submit="m-filters"]').click(function(){
        closeFiltersMobile();
        html2urlAction(false,'from data-submit="m-filters"');
        url2html('from m-filters click');
        filter();
    });

    // [F:] Clear Custom
    $('[data-filter-clear]').click(function () {
        clear[$(this).data('filter-clear')]();
        html2url('from clear custom'); //from clear custom
    });

    $('.button-up').click(function () {
        scroll_to_up();
    });

    // [F:] Gender: reset all others
    $(document).on('click', '[data-checkbox="gender"] [data-val]', function(){
        //$('[data-checkbox]:not([data-checkbox="gender"]) [data-val]').removeClass('active');
        //$('[data-type-selector] [data-val]').removeClass('active');
    });

    // [F:] Type selector
    $(document).on('click', '[data-type-selector] [data-val]', function(){
        //$('[data-checkbox]:not([data-checkbox="size"]):not([data-checkbox="gender"]) [data-val]').removeClass('active');
        // let f = $('[data-type-selector] [data-val="'+$(this).data('val')+'"]');
        // $(this).hasClass('active') ? f.removeClass('active') : f.addClass('active');
        // html2url();
        let radioValue = $(this).hasClass('active');
        if(radioValue===false) {
            $('[data-colgsizes-selector] [data-val]').removeClass('active'); // скидываем фильтр по колготкам
        }

    });

    $(document).on('click', '[data-colgsizes-selector] [data-val]', function(){
        //do_search_str('колготки');
        //$('[data-checkbox]:not([data-checkbox="size"]):not([data-checkbox="gender"]) [data-val]').removeClass('active');
        //let f = $('[data-type-selector] [data-val="'+$(this).data('val')+'"]');
        //$(this).hasClass('active') ? f.removeClass('active') : f.addClass('active');
        //alert($(this).data('val'));
        let radioValue = $(this).hasClass('active');
        if(radioValue===false){
            // if set checkbox active
            $('[data-colgsizes-selector] [data-val]').removeClass('active'); // только один вариант может быть выбран
            // скидываем галки с тип обуви, ключевые особенности, обувь с героями, размеры
            $('[data-type-selector] [data-val]').removeClass('active');
            $('[data-checkbox="features"] [data-val]').removeClass('active');
            $('[data-checkbox="brands"] [data-val]').removeClass('active');
            $('[data-checkbox="size"] [data-val]').removeClass('active');
        }
        //debugger;
        //html2url();
    });


    // [F:] Price
    $(document).on('range-changed', function () {
        // по цене применяем сразу
        //html2url();
        html2urlAction(false,'from on range-changed');
    });

    $(document).on('click', '[data-radio] [data-val]', function(){
        // сбрасываем фильтр популярных товаров
        // clear_filters_pop(); todo
        // на десктопе сразу применяем фильтры
        if( $('.append-block').is(":hidden") ) {
            html2urlAction(false, 'from on click data-radio');
        }
    });

    // $(document).on('click', '[data-radio] [data-val]', function() {
    //     alert(123) // todo
    // });

    function clear_filters_if_pop() {
        console.log('clear_filters_if_pop');
        // $('[data-checkbox] [data-val]').removeClass('active');
        // $('[data-type-selector] [data-val]').removeClass('active');
        // clear["gender"]();
        // clear["size"]();
        clear["features"]();
        clear["sort"]();
        // clear.price();
        clear.type();
        $('[data-colgsizes-selector] [data-val]').removeClass('active'); // скидываем фильтр по колготкам
        //clear["pop-filter"]();
        //html2url();
        html2urlAction(false, 'from clear_filters_not_pop');
    }

    function clear_filters_not_pop() {
        // $('[data-checkbox] [data-val]').removeClass('active');
        // $('[data-type-selector] [data-val]').removeClass('active');
        clear["gender"]();
        clear["size"]();
        clear["features"]();
        clear["sort"]();
        clear.price();
        clear.type();
        //clear["pop-filter"]();
        //html2url();
        html2urlAction(false, 'from clear_filters_not_pop');
    }

    function clear_filters_pop() {
        //alert('clear pop')
        clear["pop-filter"]();
        //html2urlAction(false,'from clear_filters_pop');
    }




    // [F:] All Checkboxes
    $(document).on('click', '[data-checkbox] [data-val]', function(){
        console.log('onclick data-checkbox begin');
        // на мобилках не применяем сразу



        let has = $(this).hasClass('active');
        let name = $(this).closest('[data-checkbox]').data('checkbox');
        let val = this.dataset['val'];
        let global = $(`[data-checkbox="${name}"]`);

        console.log(JSON.stringify({has,name,val}));

        if ($(this).hasClass('radio')) {
            global.find(`[data-val]`).removeClass('active');
            global.find(`[data-val="${val}"]`).addClass('active');
            $('.drop-down.opened').removeClass('opened');
        } else {
            global.find(`[data-val="${val}"]`)[has ? 'removeClass' : 'addClass']('active');
        }

        // эти фильтры применяем сразу
        if(name==='sort' || name==='color' || name==='mark' || name==='type' || name==='pop-filter'){
            html2url('from sort');
        }
        console.log('filter name='+name);


        
        // если нажали на фильтре популярных товаров - отключаем остальные фильтры
        // если has = false то галочку поставили, иначе сняли
        //alert('click '+name+' '+val+' '+has) //debug
        // update 2020-07-24 не скидывать другие фильтры цена,размер,пол
        if (name==='pop-filter' && val>0 && !has) {
            //clear_filters_not_pop();
            console.log('pop-filter -> clear_filters_if_pop');
            clear_filters_if_pop();
        }

        let radioValue = $(this).hasClass('active');
        if(radioValue===false) {
            if(name !==  'gender'){
                $('[data-colgsizes-selector] [data-val]').removeClass('active'); // скидываем фильтр по колготкам
            }
        }


        if (name!=='pop-filter') {
            clear_filters_pop(); // сброс фильтра популярных товаров
        }

        setTopFilters();

        return; // todotodo только по кнопке "применить"

        //debugger;
        if ($(this).hasClass('radio')) {
            global.find(`[data-val]`).removeClass('active');
            global.find(`[data-val="${val}"]`).addClass('active');
            $('.drop-down.opened').removeClass('opened');
        } else {
            global.find(`[data-val="${val}"]`)[has ? 'removeClass' : 'addClass']('active');
        }
        if(name==='pop-filter'){
            html2url('from pop-filter'); //from pop-filter
        }

        if ($(this).hasClass('radio-or-none')) {
            global.find(`[data-val]`).removeClass('active');
            // global.find(`[data-val="${val}"]`).addClass('active');
            // $('.drop-down.opened').removeClass('opened');
            global.find(`[data-val="${val}"]`)[has ? 'removeClass' : 'addClass']('active');
        } else {
            global.find(`[data-val="${val}"]`)[has ? 'removeClass' : 'addClass']('active');
        }
        // if(this.dataset['val'] === 'sale' || this.dataset['val'] === 'new' || this.dataset['val'] === 'hit'){
        // }
        if(name==='sort' || name==='color' || name==='mark'){
            html2urlAction(false,'from sort color mark');
        }


        window.is_mobile = $(window).width() < sizes.M;
        if(window.is_mobile){
            console.log('skip на is_mobile = ' + (window.is_mobile));
        }else{
            if( $('.append-block').is(":hidden") ) {
                console.log('на десктопе сразу применяем фильтры');
                html2urlAction(false,'from append-block');
            }
        }


        console.log(name);
        console.log(this.dataset['val']);
        console.log(has); //  false если ставят галочку, true если снимают галочку

        //if (!$(this).hasClass('disable-update')) html2url();

        window.is_mobile = $(window).width() < sizes.M;
        if(window.is_mobile){
            console.log('skip на is_mobile = ' + (window.is_mobile));
        }else{
            if( $('.append-block').is(":hidden") ) {
                console.log('на десктопе сразу применяем фильтры');
                if (!$(this).hasClass('disable-update')) html2url('from onclick data-checkbox');
            }
        }
    });

    // [F:] Mobile Price
    $(document).on('click', '[data-checkmax]', function(){
        $('[data-checkmax]').removeClass('active');
        $(this).addClass('active');
        $('[data-to]').val($(this).data('checkmax')).trigger('change');
    });

    // Append filters button
    $(document).on('click', '[data-sync-button]', function(){
        console.log('on click [data-sync-button]');
        $('.drop-down.opened').removeClass('opened');
        console.log('Append filters button');
        html2url('from append filters'); // from append filters
    });

    $(document).on('click', '[data-accept-filters]', function(){
        console.log('on click [data-accept-filters]');
        $('.drop-down.opened').removeClass('opened');
        html2url('from accept filters');
    });

    url2html('from start action');
    //html2urlAction('is-first','from isfirst');
    filter();

    // раз в 500 мс проверяем смену url
    setInterval(function() {
        if (location.href === current_state) return;
        if(!url_timer){
            url_timer = setTimeout(url_change,500)
        }
    }, 500);

    let url_timer;

    function url_change(){
        url_timer=null;
        console.log('URL changed is_mobile='+window.is_mobile);
        if(window.is_mobile && !window.need_url2html){
            current_state = location.href;
            window.need_url2html=null;
            return;
        }else{
            window.need_url2html=null;
        }
        // url2html('from url_change');
        // filter();
        // html2urlAction('from url_change');
        current_state = location.href;
        window.need_url2html=null;
        filter();
    }


    /* ------------------------------------------------------------ */
    let oldDecoratorHtml;

    function setTopBanner() {
        let pop_active = $('[data-checkbox="pop-filter"] .variant.active:first').html();
        if(pop_active){
            $('[data-pop-filter-active]').html(pop_active);
        }
        let fname = pop_active;

        // top banner
        if(fname){
            if(fname.indexOf('Непромокаемая обувь')>=0){
                $('.top-banner1').html('<img src="/media/banners/top/800X100_Zachita-ot-vlagi.png">');
                $('.top-banner1').fadeIn(1000);
                $('.top-banner2').html('');
            }else if(fname.indexOf('Мембрана')>=0){
                $('.top-banner1').html('<img src="/media/banners/top/800X100_Membrana.png">');
                $('.top-banner1').fadeIn(1000);
                $('.top-banner2').html('');
            }else if(fname.indexOf('Кожаная')>=0){
                $('.top-banner1').html('<img src="/media/banners/top/800X100_Koja.png">');
                $('.top-banner1').fadeIn(1000);
                $('.top-banner2').html('');
            }else if(fname.indexOf('Со светодиодами')>=0){
                $('.top-banner1').html('<img src="/media/banners/top/800X100_Svetidiodi.png">');
                $('.top-banner1').fadeIn(1000);
                $('.top-banner2').html('');
            }else if(fname.indexOf('Для школы')>=0){
                $('.top-banner1').html('<img src="/media/banners/top/800X100_Deti.png">');
                $('.top-banner1').fadeIn(1000);
                $('.top-banner2').html('');
            }else if(fname.indexOf('Для детского сада')>=0){
                $('.top-banner1').html('<img src="/media/banners/top/800X100_Deti.png">');
                $('.top-banner1').fadeIn(1000);
                $('.top-banner2').html('');
            }else if(fname.indexOf('Профилактическая')>=0){
                $('.top-banner1').html('<img src="/media/banners/top/800X100_Profilakticeskaya.png">');
                $('.top-banner1').fadeIn(1000);
                $('.top-banner2').html('');
            }
        }else{
            $('.top-banner1').html('<a href="/sami-proizvodim-obuv"><img src="/media/banners/top/2020-05-11/IMG_4515.PNG"></a>');
            // $('.top-banner2').html('<a href="/usloviya-dostavki"><img src="/media/banners/top/2020-05-11/IMG_4514.PNG"></a>');
            clear["pop-filter"]();
        }
    }

    function syncTopFilter(fromText) {
        // заполнение фильтров данными из URL

        console.log('syncTopFilter '+fromText);
        current_state = location.href;
        let url = current_state.split('?');

        params = {};
        let type_offset = 2;

        params['gender'] = [];
        for (let n in [0,1]) {
            if (location.pathname.indexOf(genders[n]) != -1) {
                params['gender'].push(n);
                type_offset++;
                $(`[data-checkbox="gender"] [data-val="${n}"]`).addClass('active');
            }
        }

        let type = location.pathname.split('/')[type_offset] || false;

        $('[data-type-selector] [data-val]').removeClass('active');
        if (type) {
            type.split(',').map(function (t) {
                $('[data-type-selector] [data-val="'+t+'"]').addClass('active');
            });
        }

        (url[1] || '').split('&').map(function(part){
            let e = part.split('=');
            if (!e[1]) return ;
            params[e[0]] = e[1].split(',');
            params[e[0]].map((v) => {
                v = decodeURIComponent(v);
                $(`[data-checkbox="${e[0]}"] [data-val="${v}"]`).addClass('active');
            });
        });

        console.log(params);

        // Sorting
        if (!params['sort']) {
            $('[data-checkbox="sort"] .variant.default').addClass('active');
        }
        $('[data-sort-active]').html($('[data-checkbox="sort"] .variant.active:first').html());

        function start_search(params){
            //$('#start-search').val(params['find']);
            //alert(params['find'])
            //$('[data-product-search]').keyup();
            let searchString =decodeURI(params['find']);
            $('[data-product-search]').val(searchString);
            do_search();
        }

        //поиск товара
        if (params['find']) {
            //$('[data-product-search]').val(params['find']);
            setTimeout(start_search,0,params);
        }

        // Materials
        let cnt = 0;
        if (params['material_top']) cnt += params['material_top'].length;
        if (params['material_sole']) cnt += params['material_sole'].length;
        $('[data-material-count]').html(cnt || 'все');

        // Colors - установка количества цветов в названии фильтрв
        if(params['color'] && params['color'].length > 0){
            $('[data-color-count]').html(params['color'].length);
        }else{
            $('[data-color-count]').html('все');
        }

        function getSizesStr() {
            // вернем строку размеров вида 23,25,27
            let res='';
            for (let item in params['size']) {
                let itemSize = params['size'][item];
                if(res===''){
                    res = itemSize;
                }else{
                    res = res +','+ itemSize;
                }
            }
            return res;
        }

        if(!oldDecoratorHtml) oldDecoratorHtml=$('[data-sort-active2]').parent().parent().find('.decorator').html();

        // Размеры - установка выбранных размеров в названии фильтра
        if (params['size'] && params['size'].length) {
            $('[data-size-active]').html('Размеры: '+getSizesStr());
            $('[data-size-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-size-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            $('[data-size-active]').html('Размеры');
        }

        // Тип обуви фильтр
        if (params['type'] && params['type'].length) {
            //$('[data-size-active]').html('Размеры: '+getSizesStr());
            $('[data-type-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-type-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            //$('[data-size-active]').html('Размеры');
        }

        // Популярные товары фильтр
        if (params['pop-filter'] && params['pop-filter'].length) {
            //$('[data-size-active]').html('Размеры: '+getSizesStr());
            $('[data-pop-filter-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-pop-filter-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            //$('[data-size-active]').html('Размеры');
        }


        // Сортировать по - установка
        if (params['sort'] && params['sort'].length) {
            let sortHtml;
            if(params['sort']=='price'){
                sortHtml = 'По возрастанию цены';
            }
            if(params['sort']=='-price'){
                sortHtml = 'По убыванию цены';
            }
            if(params['sort']=='mark_new'){
                sortHtml = 'По новинкам';
            }
            if(params['sort']=='mark_sale'){
                sortHtml = 'По скидкам';
            }
            console.log('сортировка - '+sortHtml+' '+params['sort']);
            $('[data-sort-active2]').html(sortHtml);
            //$('[data-sort-active2]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-sort-active2]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            $('[data-sort-active2]').html('Сортировать по');
        }


        //$('[data-color-count]').html(params['color'] ? params['color'].length : 'все');

        // Types
        // $('[data-radio]').each(function(){
        //     let name = 'kind';
        //     params[name] = [];
        //     $(this).find('[data-val].active').each(function(){
        //         params[name].push(this.dataset['val']);
        //     });
        // });
        // if(params['kind'] && params['kind'].length === 0){
        //     $('[data-types-count]').html('все');
        // }else{
        //     $('[data-types-count]').html(params['kind'] ? params['kind'].length : 'все');
        // }

    }


    // URL -> HTML + Params
    function url2html(fromText) {
        console.log('-> url2html '+fromText);

        // заполнение фильтров данными из URL

        current_state = location.href;
        let url = current_state.split('?');

        params = {};
        let type_offset = 2;

        // зачем то снимали галки
        //$('[data-checkbox]:not([data-checkbox="gender"]) [data-val]').removeClass('active');

        params['gender'] = [];
        for (let n in [0,1]) {
            if (location.pathname.indexOf(genders[n]) != -1) {
                params['gender'].push(n);
                type_offset++;
                $(`[data-checkbox="gender"] [data-val="${n}"]`).addClass('active');
            }
        }

        let type = location.pathname.split('/')[type_offset] || false;

        $('[data-type-selector] [data-val]').removeClass('active');
        if (type) {
            type.split(',').map(function (t) {
                $('[data-type-selector] [data-val="'+t+'"]').addClass('active');
            });
        }

        (url[1] || '').split('&').map(function(part){
            let e = part.split('=');
            if (!e[1]) return ;
            params[e[0]] = e[1].split(',');
            params[e[0]].map((v) => {
                v = decodeURIComponent(v);
                $(`[data-checkbox="${e[0]}"] [data-val="${v}"]`).addClass('active');
            });
        });

        console.log(params);

        // Sorting
        if (!params['sort']) {
            $('[data-checkbox="sort"] .variant.default').addClass('active');
        }
        $('[data-sort-active]').html($('[data-checkbox="sort"] .variant.active:first').html());

        function start_search(params){
            //$('#start-search').val(params['find']);
            //alert(params['find'])
            //$('[data-product-search]').keyup();
            let searchString =decodeURI(params['find']);
            $('[data-product-search]').val(searchString);
            do_search();
        }

        //поиск товара
        if (params['find']) {
            //$('[data-product-search]').val(params['find']);
            setTimeout(start_search,0,params);
        }


        // Pop filter
        // let popular_list = location.pathname.split('/')[type_offset] || false;
        // $('[data-pop-filter-active] [data-val]').removeClass('active');
        // if (popular_list) {
        //     popular_list.split(',').map(function (t) {
        //         $('[data-pop-filter-active] [data-val="'+t+'"]').addClass('active');
        //     });
        // }
        //$('[data-pop-filter-active] [data-val="'+t+'"]').addClass('active');
        // todo

        setTopBanner();

        // Materials
        let cnt = 0;
        if (params['material_top']) cnt += params['material_top'].length;
        if (params['material_sole']) cnt += params['material_sole'].length;
        $('[data-material-count]').html(cnt || 'все');

        // Colors - установка количества цветов в названии фильтрв
        if(params['color'] && params['color'].length > 0){
            $('[data-color-count]').html(params['color'].length);
        }else{
            $('[data-color-count]').html('все');
        }

        function getSizesStr() {
            // вернем строку размеров вида 23,25,27
            let res='';
            for (let item in params['size']) {
                let itemSize = params['size'][item];
                if(res===''){
                    res = itemSize;
                }else{
                    res = res +','+ itemSize;
                }
            }
            return res;
        }

        if(!oldDecoratorHtml) oldDecoratorHtml=$('[data-sort-active2]').parent().parent().find('.decorator').html();

        // Размеры - установка выбранных размеров в названии фильтра
        if (params['size'] && params['size'].length) {
            $('[data-size-active]').html('Размеры: '+getSizesStr());
            $('[data-size-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-size-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            $('[data-size-active]').html('Размеры');
        }

        // Тип обуви фильтр
        if (params['type'] && params['type'].length) {
            //$('[data-size-active]').html('Размеры: '+getSizesStr());
            $('[data-type-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-type-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            //$('[data-size-active]').html('Размеры');
        }

        // Популярные товары фильтр
        if (params['pop-filter'] && params['pop-filter'].length) {
            //$('[data-size-active]').html('Размеры: '+getSizesStr());
            $('[data-pop-filter-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-pop-filter-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            //$('[data-size-active]').html('Размеры');
        }


        // Сортировать по - установка
        if (params['sort'] && params['sort'].length) {
            let sortHtml;
            if(params['sort']=='price'){
                sortHtml = 'По возрастанию цены';
            }
            if(params['sort']=='-price'){
                sortHtml = 'По убыванию цены';
            }
            if(params['sort']=='mark_new'){
                sortHtml = 'По новинкам';
            }
            if(params['sort']=='mark_sale'){
                sortHtml = 'По скидкам';
            }
            console.log('сортировка - '+sortHtml+' '+params['sort']);
            $('[data-sort-active2]').html(sortHtml);
            //$('[data-sort-active2]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-sort-active2]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            $('[data-sort-active2]').html('Сортировать по');
        }


        //$('[data-color-count]').html(params['color'] ? params['color'].length : 'все');

        // Types
        // $('[data-radio]').each(function(){
        //     let name = 'kind';
        //     params[name] = [];
        //     $(this).find('[data-val].active').each(function(){
        //         params[name].push(this.dataset['val']);
        //     });
        // });
        // if(params['kind'] && params['kind'].length === 0){
        //     $('[data-types-count]').html('все');
        // }else{
        //     $('[data-types-count]').html(params['kind'] ? params['kind'].length : 'все');
        // }

        // // популярные коллекции
        // $('[data-radio-pop]').each(function(){
        //     let name = 'pop';
        //     params[name] = [];
        //     $(this).find('[data-val].active').each(function(){
        //         params[name].push(this.dataset['val']);
        //     });
        // });
        // if(params['pop'] && params['pop'].length === 0){
        //     clear["pop-filter"]();
        // }


        $.post(null, { meta: true }, function (page) {
            $('h1').html(page.h1);
            $('title').html(page.title);
        }, "json");
    }

    let html2url_timer;
    // HTML -> Params + URL
    function html2url(from) {
        console.log('html2url begin '+from);
        //setTimeout(html2urlAction, 400);
        if(!html2url_timer){
            html2url_timer = setTimeout(setClearFiltersEnabledOrDisabled, 10, 'html2url');
        }
        //setClearFiltersEnabledOrDisabled();
    }



    function setTopFilters() {
        function getSizesStr(params){
            // вернем строку размеров вида 23,25,27
            let res='';
            for (let item in params['size']) {
                let itemSize = params['size'][item];
                if(res===''){
                    res = itemSize;
                }else{
                    res = res +','+ itemSize;
                }
            }
            return res;
        }

        // синхронизируем левый и верхний фильтры
        if(!oldDecoratorHtml) oldDecoratorHtml=$('[data-sort-active2]').parent().parent().find('.decorator').html();

        let params={};
        $('[data-checkbox]').each(function(){
            let name = this.dataset['checkbox'];
            params[name] = [];
            $(this).find('[data-val].active').each(function(){
                params[name].push(this.dataset['val']);
            });
        });
        console.log(JSON.stringify(params));

        // Размеры - установка выбранных размеров в названии фильтра
        if (params['size'] && params['size'].length) {
            $('[data-size-active]').html('Размеры: '+getSizesStr(params));
            $('[data-size-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-size-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            $('[data-size-active]').html('Размеры');
        }

        // Тип обуви фильтр
        if (params['type'] && params['type'].length) {
            $('[data-type-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-type-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
        }
        // все меняем на количество типов обуви
        if(params['type'] && params['type'].length === 0){
            $('[data-types-count]').html('все');
        }else{
            $('[data-types-count]').html(params['type'] ? params['type'].length : 'все');
        }

        // Популярные товары фильтр
        if (params['pop-filter'] && params['pop-filter'].length) {
            //$('[data-size-active]').html('Размеры: '+getSizesStr());
            $('[data-pop-filter-active]').parent().parent().find('.decorator').html('X');
        }else{
            $('[data-pop-filter-active]').parent().parent().find('.decorator').html(oldDecoratorHtml);
            //$('[data-size-active]').html('Размеры');
        }

        //todotodo цвета меняем все на количество цветов
        if(params['color'] && params['color'].length){
            $('[data-color-count]').html(params['color'].length);
        }else{
            $('[data-color-count]').html('все');
        }

        // todotodo текст в верхнем фильтре сортировки
        // Сортировать по - установка
        if (params['sort'] && params['sort'].length) {
            let sortHtml;
            if (params['sort'] == 'price') {
                sortHtml = 'По возрастанию цены';
            }
            if (params['sort'] == '-price') {
                sortHtml = 'По убыванию цены';
            }
            if (params['sort'] == 'mark_new') {
                sortHtml = 'По новинкам';
            }
            if (params['sort'] == 'mark_sale') {
                sortHtml = 'По скидкам';
            }
            $('[data-sort-active2]').html(sortHtml);
        }

    }



    function setClearFiltersEnabledOrDisabled(fromText) {
        console.log('setClearFiltersEnabledOrDisabled begin');
        html2url_timer=null;
        params = {};

        $('[data-product-search]').val('');

        $('[data-checkbox]').each(function(){
            let name = this.dataset['checkbox'];
            params[name] = [];
            $(this).find('[data-val].active').each(function(){
                if(name!=='type'){
                    params[name].push(this.dataset['val']);
                }
            });
        });

        // $('[data-radio]').each(function(){
        //     let name = 'kind';
        //     params[name] = [];
        //     $(this).find('[data-val].active').each(function(){
        //         params[name].push(this.dataset['val']);
        //     });
        // });

        $('[data-radio]').each(function(){
            let name = this.dataset['checkbox'];
            params[name] = [];
            $(this).find('[data-val].active').each(function(){
                if(name!=='type') {
                    params[name].push(this.dataset['val']);
                }
            });
        });

        update_type_description();

        if (params['sort'] && params['sort'] == 'mark_hit') {
            delete params['sort'];
        }

        let price = [$('[data-from]').val(), $('[data-to]').val()];
        if (price[0] != 0 || price[1] != $('[data-to]').attr('max')) params['price'] = price;

        // 2022 цен на рознице теперь нет и фильтра тоже
        delete (params['price']);

        let data = [];
        for (let k in params) {
            if (!params[k].length) continue;
            if (k === 'gender') continue;
            let value = params[k].join(','); // encodeURIComponent
            if (value) data.push(k + '=' + value);
        }

        let filters = data.join('&');
        if (filters) filters = '?' + filters;
        let tp = [];
        $('[data-type-selector] .active').each(function () {
            let c = $(this).data('val');
            if (tp.indexOf(c) == -1) tp.push(c);
        });

        //$('[data-clear="all"]').hide();
        if (tp.length || data.length > 0) $('[data-clear="all"]').show();

        $('[data-filter-clear]').hide();
        $('[data-clear="m-filters"]').addClass('disabled');

        if (params['sort'] && params['sort'].length && params['sort'] != 'mark_hit') {
            //$('[data-filter-clear="sort"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['price'] && params['price'].length) {
            //$('[data-filter-clear="price"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['size'] && params['size'].length) {
            //$('[data-filter-clear="size"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['brand'] && params['brand'].length) {
            //$('[data-filter-clear="brands"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['features'] && params['features'].length) {
            //$('[data-filter-clear="features"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        // if (params['kind'] && params['kind'].length) {
        //     //$('[data-filter-clear="kind"]').show();
        //     $('[data-clear="m-filters"]').removeClass('disabled');
        // }

        // console.log(params);
        let gender = '';
        if (params['gender'] && params['gender'].length == 1) {
            gender = '/' + genders[params['gender'][0]];
            $('[data-clear="m-filters"]').removeClass('disabled');
        }

        $('[data-clear="m-type"]').addClass('disabled');
        if (tp.length) {
            $('[data-clear="m-type"]').removeClass('disabled');
        }

        // отобразим фильтры в url
        let URL;
        URL = catalog_base + gender + (tp.length ? ('/' + tp.join(',')) : '') + filters;
        setTimeout(function () {
            console.log('> pushState: ' + URL);
            console.log('from '+fromText);
            history.pushState('Сортировка', {}, URL);
        }, 350);

        return {URL,filters,gender};

    }

    $(document).on('click', '.drop-down .selected .decorator', function(){
        console.log('on click decorator ');//+$(this).parent().parent().find('.selected').html());
        if($(this).html()==='X'){
            if($(this).parent().parent().find('.selected').hasClass('isSizes')){
                console.log('очистка фильтра size');
                clear.size();
            }
            if($(this).parent().parent().find('.selected').hasClass('isTypes')){
                console.log('очистка фильтра type');
                clear.type();
            }
            if($(this).parent().parent().find('.selected').hasClass('isPopFilter')){
                console.log('очистка фильтра pop-filter');
                clear["pop-filter"]();
            }

            setTopFilters();

            // accept filters
            html2url('from on click decorator');
        }
    });


    function update_type_description() {
        let params={};
        let text= 'Детская обувь от фирменного бренда KAKADU произведена с заботой о маленьких ножках. Качественные материалы и передовые технологии обеспечат детям комфорт в носке. Модные фасоны и актуальные модели обуви раскроют индивидуальность ребенка.';
        $('[data-radio]').each(function(){
            // let name = 'type';
            // params[name] = [];
            let kinds = $(this).find('[data-val].active').toArray();
            if(kinds.length>0){
                let titleKind = [];
                for(let i=0;i<kinds.length;i++){
                    let kind = kinds[i].dataset['val'];
                    if( kind === 'kedy') {
                        titleKind.push('Кеды');
                        text = 'Детские кеды KAKADU созданы для увлекательных прогулок. Яркие цвета, стильные принты, изображения мультгероев на обуви завершат модный образ ребенка. Все модели выполнены из качественных материалов, а мягкая подкладка и стелька обеспечат комфорт маленьким детским ножкам. ';
                    }
                    if( kind === 'krossovki') {
                        titleKind.push('Кроссовки');
                        text = 'Детские кроссовки KAKADU сделаны в соответствии со всеми последними трендами. Массивная, но легкая подошва, кислотные цвета и стиль колор блок. Для самых маленьких модников представлена коллекция с изображением мультгероев и светодиодами.  ';
                    }
                    if( kind === 'tufli') {
                        titleKind.push('Туфли');
                        text = 'Туфли для девочек и мальчиков – это незаменимый предмет гардероба, который вы также можете найти в ассортименте бренда KAKADU. Практически все модели оснащены подсводником, поддерживающим свод стопы. Подошва не оставляет черных следов на поверхностях. ';
                    }
                    if( kind === 'sapogi') {
                        titleKind.push('Сапоги');
                        text = 'Детские сапоги KAKADU, выполненные из качественных материалов, защитят ножки от ветра или холода и прослужат не один сезон. Обувь не сковывает движения благодаря гибкой подошве. Сапоги очень комфортны в носке.';
                    }
                    if( kind === 'botinki') {
                        titleKind.push('Ботинки');
                        text = 'Выбирая детские ботинки KAKADU, вы выбираете функциональность, удобство и практичность. Все модели надежно фиксируют стопу благодаря застежкам-липучкам или молнии с затянутой по ноге шнуровкой.';
                    }
                    if( kind === 'polusapogi') {
                        titleKind.push('Полусапоги');
                        text = 'Детские полусапоги KAKADU – это комфортная обувь, отлично сохраняющая тепло и отличающаяся большим удобством при надевании. Подошва не будет скользить благодаря хорошему протектору и устойчивому каблуку. В ассортименте представлены классические и модные модели.';
                    }
                    if( kind === 'polubotinki') {
                        titleKind.push('Полуботинки');
                        text = 'Детские полуботинки KAKADU отличаются ярким и стильным дизайном, а также хорошо сидят на ноге. Удобная колодка и дышащие материалы обеспечивают максимальный комфорт в носке. ';
                    }
                    if( kind === 'membrannaya-obuv') {
                        titleKind.push('Мембранная обувь');
                        text = 'Детская мембранная обувь KAKADU – это гарантия комфорта и здоровья вашего ребенка. Качественная мембрана CROSSTEX обеспечит защиту от холода и влаги.  Оригинальный дизайн придется по вкусу каждому ребенку. У нас вы точно найдете надежную обувь для зимы.';
                    }
                    if( kind === 'uggi') {
                        titleKind.push('Угги');
                        text = 'Детские угги KAKADU – это отличный вариант обуви для зимы. Натуральна кожа и мех сохранят ножки в тепле в самое холодное время года. У нас вы найдете широкий выбор моделей как для девочек, так и для мальчиков. ';
                    }
                    if( kind === 'plyazhnaya-obuv') {
                        titleKind.push('Пляжная обувь');
                        text = 'С детской пляжной обувью KAKADU бегать по песку будет вдвойне веселее! Красочные модели с яркими принтами, встроенными светодиодами и облегченной подошвой созданы для лета. Обувь подходит также для бассейна.';
                    }
                    if( kind === 'rezinovye-sapogi') {
                        titleKind.push('Резиновые сапоги');
                        text = 'Детские резиновые сапоги KAKADU – это выгодное и практичное решение для прогулок в дождливую погоду. Ребенок может сколько угодно прыгать по лужам, но влага не попадет внутрь обуви. Некоторые модели оснащены непромокаемой манжеткой с фиксирующим шнурком на голенище или ручками для удобного надевания.';
                    }
                    if( kind === 'sandalii') {
                        titleKind.push('Сандалии');
                        text = 'Детские сандалии KAKADU выполнены из натуральной кожи. Кожа обеспечивает естественную вентиляцию и создает благоприятный микроклимат в обуви. Наличие подсводника поддерживает свод стопы.';
                    }
                    if (kind === 'dutiki') {
                        titleKind.push('Дутики');
                        text = 'Детские дутики KAKADU литьевого метода крепления подошвы обладают повышенной влагостойкостью. Они легкие и устойчивы к истиранию. Тепло маленьким детским ножкам обеспечивает натуральная шерсть в подкладке.';
                    }
                    if (kind === 'snikersy') {
                        titleKind.push('Сникерсы');
                        text = 'Детские сникерсы на танкетке помогут создать свой неповторимый образ. Модели выполнены в спортивном стиле, но подходят для ежедневной носки. Подошва сникерсов способна выдержать многократные изгибы за счет прочности и долговечности материала, из которого она изготовлена.';
                    }
                    if (kind === 'kedy-vysokie') {
                        titleKind.push('Высокие кеды');
                        text = 'Детские высокие кеды KAKADU превратились из просто удобной обуви в модную. Спрос на спортивный стиль остается высоким, а подобные модели кед являются одними из самых популярных видов обуви.';
                    }
                    if (kind === 'bosonozhki') {
                        titleKind.push('Босоножки');
                        text = 'Детские босоножки KAKADU – идеальная обувь для теплой погоды. Они отлично завершат повседневный образ девочки. В босоножках присутствует подсводник – специальный ортопедический валик на стельке, который не позволяет детским ножкам уставать.';
                    }
                }
                // console.log('titleKind');
                // console.log(titleKind);
                if(titleKind.length>0){
                    titleKind = titleKind.join(', ');
                    //let oldTitle = $('title').html();
                    $('title').html(titleKind + ' - детская обувь в интернет-магазине Kakadu');
                }else{
                    $('title').html('Каталог детской обуви в интернет-магазине Kakadu');
                }
            }else{
                text= 'Детская обувь от фирменного бренда KAKADU произведена с заботой о маленьких ножках. Качественные материалы и передовые технологии обеспечат детям комфорт в носке. Модные фасоны и актуальные модели обуви раскроют индивидуальность ребенка.';
                $('title').html('Каталог детской обуви в интернет-магазине Kakadu');
            }
            // $(this).find('[data-val].active').each(function(){
            //     params[name].push(this.dataset['val']);
            //     let kind = this.dataset['val'];
            //     if(params[name].length===1) {
            //     }
            // });
            // if(params[name].length!==1) {
            // }

            $('.type-description').text(text);
        });

    }

    function scroll_to_up() {
        $('html, body').stop().animate({scrollTop: 0}, 100, 'swing');
    }

    let html2urlAction_timer;
    function html2urlAction(first,from) {
        if(!html2urlAction_timer){
            html2urlAction_timer = setTimeout(html2urlAction2,100,first,from);
        }
    }

    function html2urlAction2(first,from) {
        console.log('html2urlAction begin '+from);
        html2urlAction_timer=null;
        if (!first) {
            localStorage.setItem('items-on-page # ' + location.href, 12);
        }else{
            console.log('first true');
        }

        console.log('-> html2url');
        params = {};

        setTopBanner();

        $('[data-product-search]').val('');

        $('[data-checkbox]').each(function(){
            let name = this.dataset['checkbox'];
            params[name] = [];
            $(this).find('[data-val].active').each(function(){
                params[name].push(this.dataset['val']);
            });
        });

        if (params['sort'] && params['sort'] == 'mark_hit') {
            delete params['sort'];
        }
        // if (params['sort'] && params['sort'] == 'mark_new') {
        //     delete params['sort'];
        // }

        let price = [$('[data-from]').val(), $('[data-to]').val()];
        if (price[0] != 0 || price[1] != $('[data-to]').attr('max')) params['price'] = price;

        let data = [];
        for (let k in params) {
            if (!params[k].length) continue;
            if (k === 'gender') continue;
            let value = params[k].join(','); // encodeURIComponent
            if (value) data.push(k + '=' + value);
        }

        let filters = data.join('&');
        if (filters) filters = '?' + filters;
        let tp = [];
        $('[data-type-selector] .active').each(function () {
            let c = $(this).data('val');
            if (tp.indexOf(c) == -1) tp.push(c);
        });

        //$('[data-clear="all"]').hide();
        if (tp.length || data.length > 0) $('[data-clear="all"]').show();

        $('[data-filter-clear]').hide();
        $('[data-clear="m-filters"]').addClass('disabled');

        if (params['sort'] && params['sort'].length && params['sort'] != 'mark_hit') {
            //$('[data-filter-clear="sort"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['price'] && params['price'].length) {
            //$('[data-filter-clear="price"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['size'] && params['size'].length) {
            //$('[data-filter-clear="size"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['brand'] && params['brand'].length) {
            //$('[data-filter-clear="brands"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }
        if (params['features'] && params['features'].length) {
            //$('[data-filter-clear="features"]').show();
            $('[data-clear="m-filters"]').removeClass('disabled');
        }

        //console.log(params);
        let gender = '';
        if (params['gender'] && params['gender'].length == 1) {
            gender = '/' + genders[params['gender'][0]];
            $('[data-clear="m-filters"]').removeClass('disabled');
        }

        $('[data-clear="m-type"]').addClass('disabled');
        if (tp.length) {
            $('[data-clear="m-type"]').removeClass('disabled');
        }

        let filters_data = setClearFiltersEnabledOrDisabled('from html2urlAction2');
        setTimeout(update_bottom_banners,100,filters_data);
    }

    function update_bottom_banners(filters_data) {
        $('.banners_bottom').addClass('hidden');
        let jsonobj ={};
        jsonobj.id='update_bottom_banners';
        jsonobj.data=filters_data;
        $.ajax({
            url: "/ajax",
            cache: false,
            type: "GET",
            // headers: {
            //     // 'CSRF-Token': token
            // },
            data: jsonobj,
            contentType: 'application/json; charset=utf-8',
            dataType: "json",
            success: function (data) {
                if (typeof data === "object") {
                    console.log('get json message:');
                    console.log(data);
                    $('.banner_bottom_1').html(data[0]);
                    $('.banner_bottom_2').html(data[1]);
                    $('.banner_bottom_3').html(data[2]);
                    $('.banner_bottom_4').html(data[3]);
                    $('.banners_bottom').removeClass('hidden');
                } else {
                    let data2 = JSON.parse(data);
                    if(data2) {
                        //parseservermessageLocal(data);
                    }else{
                        console.error('get not json message:');
                        console.error(data);
                    }
                }
            },
            error: function (e) {
                console.error(e)
            }
        });

    }

    // Products by filters
    function filter() {
        console.log('-> filter');

        let filtered = [];
        let type_id = [];
        let colgfilter = [];
        let warehouseFilter=[];
        $('[data-type-selector] [data-id].active').map(function () {
            type_id.push($(this).data('id'));
        });
        $('[data-colgsizes-selector] [data-id].active').map(function () {
            colgfilter.push($(this).data('id'));
        });
        $('[data-warehouse-selector] [data-id].active').map(function () {
            warehouseFilter.push($(this).data('id'));
        });

        let types = {};
        let brands = {};
        let features = {};
        let providers = {};
        //$(`[data-checkbox="features"] [data-val]`).hide();

        for(let i=0;i<100;i++){
            features[i]=0;
        }

        let wareCount=0;

        products.filter(function (p) {
            if (!params['gender'] || params['gender'].length !== 1) return true;
            return params['gender'][0] == p['gender'];
        }).map(function (e) {
            if (!types[e.type_id]) types[e.type_id] = 0;
            types[e.type_id] += 1;

            if (!brands[e.brand]) brands[e.brand] = 0;
            brands[e.brand] += 1;

            // for (let i in e.available3) {
            //     if (!providers[e.available3[i].warehouse]) providers[e.available3[i].warehouse] = 0;
            //     providers[e.available3[i].warehouse] += 1;
            // }
            // if(e.available3.length==0){
            //     return false;
            // }
            // console.log(providers);

            // фильтр по магазинамм
            // let skipWarehouse=false;
            // if (warehouseFilter && warehouseFilter.length) {
            //     for(let i=0;i<warehouseFilter.length;i++){
            //         //console.log(JSON.stringify(p.name));
            //         if(e.ware_type !== 2){
            //             skipWarehouse=true;
            //         }else{
            //             if(warehouseFilter[i]==='все'){
            //                 skipWarehouse=false;
            //                 break;
            //             }else{
            //                 if(e.name.indexOf(warehouseFilter[i])>0){
            //                     skipWarehouse=false;
            //                     break;
            //                 }else{
            //                     skipWarehouse=true;
            //                 }
            //             }
            //         }
            //     }
            //     if(skipWarehouse){
            //         //console.log('пропуск skip_colg');
            //         return false;
            //     }
            // }


            let skip_colg=false;
            if (colgfilter && colgfilter.length) {
                for(let i=0;i<colgfilter.length;i++){
                    //console.log(JSON.stringify(p.name));
                    if(e.ware_type !== 2){
                        skip_colg=true;
                    }else{
                        if(colgfilter[i]==='все'){
                            skip_colg=false;
                            break;
                        }else{
                            if(e.name.indexOf(colgfilter[i])>0){
                                skip_colg=false;
                                break;
                            }else{
                                skip_colg=true;
                            }
                        }
                    }
                }
                if(skip_colg){
                    //console.log('пропуск skip_colg');
                    return false;
                }
            }

            // Type
            if (type_id.length && type_id.indexOf(e['type_id']) == -1) {
                //console.log('пропуск type_id');
                return false;
            }

            // скроем скидка 30% (ошибка 1с, ждем пока исправят)
            // if(e.mark_sale==30){
            //     return false;
            // }

            // Size
            if (params['size'] && params['size'].length) {
                let valid = false;
                for (let i in e['sizes']) {
                    if (params['size'].indexOf(e['sizes'][i].size + '') != -1) valid = true;
                }
                if (!valid) {
                    //console.log('пропуск valid');
                    return false;
                }
            }

            // Price
            if (params['price']) {
                if (e['price_'] < params['price'][0] || e['price_'] > params['price'][1]) {
                    //console.log('пропуск price');
                    return false;
                }
            }

            // Brands
            let brands_found=false;

            function encode_utf8(s) {
                let res=s;
                try{
                    res = unescape(encodeURIComponent(s));
                }catch (e) {

                }
                return res;
            }

            function decode_utf8(s) {
                let res=s;
                try{
                    res = decodeURIComponent(s);
                }catch (e) {
                    console.log('ошибка раскодирования '+s);
                }
                return res;
            }

            //console.log('ищем бренды '+JSON.stringify(params['brands']));
            if (params['brands'] && params['brands'].length) {
                for (let i in params['brands']) {
                    let brand = decode_utf8(params['brands'][i]);
                    if (e.brand.indexOf(brand) !== -1 ) {
                        console.log('бренд найден '+e.brand+' искали '+brand);
                        brands_found=true;
                    }
                }
                if(!brands_found){
                    console.log('бренд не найден '+e.brand);
                    return false;
                }
            }

            // Providers
            let providers_found=false;
            if (params['warehouse'] && params['warehouse'].length) {
                for (let i in params['warehouse']) {
                    //console.log('перебираем чекбоксы providers');
                    for (let j in e.available3) {
                        //console.log('перебираем providers в товаре');
                        if (e.available3[j].warehouse.indexOf(params['warehouse'][i]) !== -1 ) {

                            // если стоит фильтр по размерам
                            if (params['size'] && params['size'].length) {
                                for (let k in params['size']) {
                                    if (e.available3[j].size == params['size'][k]) {
                                        providers_found=true;
                                        break;
                                    }
                                }
                            }else{
                                providers_found=true;
                                break;
                            }
                            //console.log('нашли магазин');
                        }
                    }
                }
                if(!providers_found){
                    console.log('пропуск товара');
                    return false;
                }
            }

            let featuresArr=e.feature;
            for(let item in featuresArr){
                // только для выбранных типов
                if (!features[featuresArr[item]]) features[featuresArr[item]] = 0;
                features[featuresArr[item]] += 1;
            }

            // Features
            let features_found=false;
            if (params['features'] && params['features'].length) {
                for (let i in params['features']) {
                    //if (e.feature.indexOf(params['features'][i]) === -1) return false;
                    if (e.feature.indexOf(params['features'][i]) !== -1 ) {
                        features_found=true;
                    }
                }
                if(!features_found){
                    //console.log('пропуск features');
                    return false;
                }
            }

            // Collections Popular
            if (params['pop-filter'] && params['pop-filter'].length) {
                for (let i in params['pop-filter']) {
                    if (e.collection.indexOf(params['pop-filter'][i]) === -1) {
                        //console.log('пропуск popular');
                        return false;
                    }
                }
            }

            // Material
            if (params['material_top'] && params['material_top'].length) {
                if (!common(params['material_top'], e['materials_top'])) return false;
            }
            if (params['material_sole'] && params['material_sole'].length) {
                if (!common(params['material_sole'], e['materials_sole'])) return false;
            }

            // Color
            if (params['color'] && params['color'].length && params['color'].indexOf(e['color_id'] + '') === -1) {
                //console.log('пропуск color');
                return false;
            }

            // Mark
            if (params['mark'] && params['mark'].length) {
                // let valid = false;

                // теперь не используем метки NEW
                // for (let i in params['mark']) {
                //     if ( !e['mark_'+params['mark'][i]] ) {
                //         console.log('пропуск mark');
                //         return false;
                //     }
                // }


                // if (e['mark_sale'] && params['mark'].indexOf('sale') !== -1) valid = true;
                // if (e['mark_hit'] && params['mark'].indexOf('hit') !== -1) valid = true;
                // if (e['mark_new'] && params['mark'].indexOf('new') !== -1) valid = true;
                // if (!valid) return false;
            }

            e.feature.map(function(id){
                $(`[data-checkbox="features"] [data-val="${id}"]`).show();
            });

            wareCount++;
            //console.log('добавили товар '+JSON.stringify(e)+' '+wareCount);
            filtered.push(e);
        });

        // console.log(params);

        function sortByNew(a,b) {
            // в приритете новая коллекция
            var sorterA=0;
            var sorterB=0;
            //console.log('сравниваем '+JSON.stringify({as:a.season,bs:b.season}));
            // if(b.season.indexOf('Зима')>=0){
            //     //console.log('b Зима');
            //     sorterB = 2000;
            // }
            // if(a.season.indexOf('Зима')>=0){
            //     //console.log('a Зима');
            //     sorterA = 2000;
            // }
            // if(b.season.indexOf('Лето')>=0){
            //     //console.log('b Лето');
            //     sorterB = 1000;
            // }
            // if(a.season.indexOf('Лето')>=0){
            //     //console.log('a Лето');
            //     sorterA = 1000;
            // }
            // if(b.season.indexOf('a2c7ac1f6bad740411eb728a6ad58a12')>=0 || b.season.indexOf('Зима 2022')>=0){
            //     sorterB = 2500;
            // }
            // if(a.season.indexOf('a2c7ac1f6bad740411eb728a6ad58a12')>=0 || a.season.indexOf('Зима 2022')>=0){
            //     sorterA = 2500;
            // }
            // if(b.season.indexOf('11344:a2c7ac1f6bad740411ebefa20dd5f5dc')>=0 || b.season.indexOf('Лето 2022')>=0){
            //     sorterB = 1000;
            // }
            // if(a.season.indexOf('11344:a2c7ac1f6bad740411ebefa20dd5f5dc')>=0 || a.season.indexOf('Лето 2022')>=0){
            //     sorterA = 1000;
            // }
            if(a.season.indexOf('Лето')>=0){
                sorterA = 1000;
            }
            if(a.season.indexOf('Зима')>=0){
                sorterA = 2000;
            }
            if(a.season.indexOf('Зима 2024')>=0){
                sorterA = 3000;
            }

            //console.log('set sorterA 1 '+sorterA);
            //console.log('set sorterB 1 '+sorterB);

            if (+a.sort > 0) {
                sorterA = a.sort;
                //console.log('set sorterA '+sorterA);
            }
            if (+b.sort > 0) {
                sorterB = b.sort;
                //console.log('set sorterB '+sorterB);
            }

            // if (+a.mark_new > 0) {
            //     sorterA += a.mark_new;
            // }
            // if (+b.mark_new > 0) {
            //     sorterB += b.mark_new;
            // }

            //console.log({art_b: b.art, art_a: a.art, sorterB, sorterA});
            if(sorterA === sorterB){
                let sortval=(b.art>a.art)?1:-1;
                return sortval;
            }
            return sorterB - sorterA;

            // if(b.season.indexOf('Зима')>=0 && b.mark_sale>=50){
            //     //console.log('зима 50%'+b.art);
            //     return 10;
            // }else{
            //     //console.log('сезон '+a.season);
            // }

            // // лето выше в списке
            // if(b.season.indexOf('Лето')>=0){
            //     return 1;
            // }
            // if(a.season.indexOf('Лето')>=0){
            //     return -1;
            // }
        }

        function alternationByMaleFemale(inArray){
            // чередование мальчик-девочка
            let m1=[],m2=[];
            for(let i in inArray){
                let item = inArray[i];
                if(item['gender']==0){
                    m1.push(item);
                }else{
                    m2.push(item);
                }
            }
            let res = [];
            let i=0;
            while(true){
                if(m1[i])
                    res.push(m1[i]);
                if(m2[i])
                    res.push(m2[i]);
                if(i>m1.length && i>m2.length){
                    break;
                }
                i++;
            }
            return res;
        }

        function filterBy(by,p){
            let removeArr =[];
            if (by === 'shkola') {
                console.warn(p);
                if(p.art=='9775a'){
                    console.warn(p);
                }
                var kogannaya_stelka = ['1','20'];
                if(kogannaya_stelka){
                    var intersection = kogannaya_stelka.filter(e => p.materials_insole.includes(e));
                    if(intersection && intersection.length > 0) {
                        return true;
                    }
                }
                return false;
                // id(p.materials_insole==1 || p.materials_insole==20) {
                //     return true;
                // }
                //return false;
                //removeArr = ['8111B', '8594B', '8085B', '8083B', '7377B', '8073C', '8069B', '7715B', '7715A'];
                //zzzzzzzzzzzzzzzzzzz
                //params['material_top'] params['material_sole']
                // materials_insole // стелька
                // materials_lining // подкладка
                // materials_sole // подошва
                // materials_top
            }
            // if(removeArr.includes(p.art)){
            //     return false;
            // }
            return true;
        }

        if (params['filter'] && params['filter'].length) {
            params['filter'].map(function (by) {
                if (by === 'shkola') {
                    console.log('фильтруем по '+by);
                    filtered = filtered.filter(function (p) {
                        return filterBy(by,p);
                    });
                }
            });
        }

        if (params['sort'] && params['sort'].length) {
            params['sort'].map(function (by) {
                console.log('сортировка по '+by);
                if (by == '-price') filtered.sort(function (a, b) {
                    if(b.price_ == a.price_){
                        let sortval=(b.art>a.art)?1:-1;
                        return sortval;
                    }
                    return b.price_ - a.price_;
                });
                if (by == 'price') filtered.sort(function (a, b) {
                    if(a.price_ == b.price_){
                        let sortval=(b.art>a.art)?1:-1;
                        return sortval;
                    }
                    return a.price_ - b.price_;
                });

                // сортировка по скидкам
                // новый алгоритм - сначала зима потом мембрана угги ботинки
                // todotodo
                if (by == 'mark_sale') filtered.sort(function (a, b) {

                    let sorterA=0,sorterB=0;
                    if(b.season.indexOf('Зима')>=0 && b.mark_sale>0 ){
                        sorterB = 1000;
                    }
                    if(a.season.indexOf('Зима')>=0 && a.mark_sale>0 ){
                        sorterA = 1000;
                    }
                    if(b.type.indexOf('мембранная обувь')>=0 && b.mark_sale>0 ){
                        sorterB += 300;
                    }
                    if(a.type.indexOf('мембранная обувь')>=0 && a.mark_sale>0 ){
                        sorterA += 300;
                    }
                    if(b.type.indexOf('угги')>=0 && b.mark_sale>0 ){
                        sorterB += 200;
                    }
                    if(a.type.indexOf('угги')>=0 && a.mark_sale>0 ){
                        sorterA += 200;
                    }
                    if(b.type.indexOf('ботинки')>=0 && b.mark_sale>0 ){
                        sorterB += 100;
                    }
                    if(a.type.indexOf('ботинки')>=0 && a.mark_sale>0 ){
                        sorterA += 100;
                    }
                    // сверху 20% снизу 50%
                    if(a.mark_sale>=20 && a.mark_sale<=50){
                        sorterA += (100-a.mark_sale);
                        sorterB += (100-b.mark_sale);
                    }else{
                        sorterA += a.mark_sale;
                        sorterB += b.mark_sale;
                    }

                    if(sorterA === sorterB){
                        let sortval=(b.art>a.art)?1:-1;
                        return sortval;
                    }
                    //console.log('сравнение '+b.art+' и '+a.art+' '+JSON.stringify({sorterB,sorterA}));
                    return sorterB - sorterA;
                });

                function sortByBannerVesna(a,b) {
                    // резина кроссовки кеды
                    let sorterA=0,sorterB=0;
                    //console.log('тестируем '+JSON.stringify(b));
                    if(b.season.indexOf('Лето 2021')>=0){
                        sorterB = 2000;
                    }
                    if(a.season.indexOf('Лето 2021')>=0){
                        sorterA = 2000;
                    }
                    if(b.type.indexOf('резиновые сапоги')>=0 ){
                        sorterB += 900;
                    }
                    if(a.type.indexOf('резиновые сапоги')>=0 ){
                        sorterA += 900;
                    }
                    if(b.type.indexOf('кроссовки')>=0 ){
                        sorterB += 800;
                    }
                    if(a.type.indexOf('кроссовки')>=0 ){
                        sorterA += 800;
                    }
                    if(b.type.indexOf('кеды')>=0 ){
                        sorterB += 700;
                    }
                    if(a.type.indexOf('кеды')>=0 ){
                        sorterA += 700;
                    }

                    sorterA += a.mark_sale;
                    sorterB += b.mark_sale;

                    if(sorterA === sorterB){
                        let sortval=(b.art>a.art)?1:-1;
                        return sortval;
                    }
                    //console.log('сравнение '+b.art+' и '+a.art+' '+JSON.stringify({sorterB,sorterA}));
                    return sorterB - sorterA;
                }





                if (by == 'banner_mal_vesna') filtered.sort(function (a, b) {
                    return sortByBannerVesna(a,b);
                });

                if (by == 'banner_dev_vesna') filtered.sort(function (a, b) {
                    return sortByBannerVesna(a,b);
                });

                if (by == 'mark_new') {
                    filtered.sort(function (a, b) {
                        return sortByNew(a, b);
                    });
                    filtered = alternationByMaleFemale(filtered);
                }
                if (by == 'mark_hit') filtered.sort(function (a, b) {
                    if(b.mark_hit == a.mark_hit){
                        let sortval=(b.art>a.art)?1:-1;
                        return sortval;
                    }
                    return b.mark_hit - a.mark_hit;
                });
            });
        }else{
            // если сортировка не задана, сортируем как по новизне mark_new
            filtered.sort(function (a, b) {
                return sortByNew(a,b);
            });
            filtered = alternationByMaleFemale(filtered);
        }

        // количество в "тип обуви"
        $(`[data-type-selector] [data-id]`).hide();
        for (let id in types) {
            $(`[data-type-selector] [data-id="${id}"]`).show().find('.count').html(types[id]);
        }

        // количество в "обувь с героями"
        $(`[data-brand-selector] [data-id]`).hide();
        for (let id in brands) {
            $(`[data-brand-selector] [data-id="${id}"]`).show().find('.count').html(brands[id]);
        }

        // количество в ключевых особенностях
        $(`[data-features-selector] [data-id]`).hide();
        for (let id in features) {
            // if(id==24){
            //     alert($(`[data-feature-selector] [data-id="${id}"]`).show().find('.count').html());
            // }else{
            //     alert(id);
            // }
            //console.log(features[id]+' for '+id);
            $(`[data-feature-selector] [data-id="${id}"]`).show().find('.count').html(features[id]);
            if($(`[data-feature-selector] [data-id="${id}"]`).show().find('.count').html()=='0'){
                //$(`[data-feature-selector] [data-id="${id}"]`).show().find('.count').html('0');
                $(`[data-feature-selector] [data-id="${id}"]`).hide();
            }
        }

        console.log('display 1 отфильтровано товаров: '+filtered.length);
        display(filtered); //1
    }

    // Display items
    function display(filtred) {
        let loading = false;

        console.log('отфильтровано товаров: '+filtred.length);
        localStorage.setItem('last-page # ' + location.href, location.href);
        localStorage.setItem('items-on-page # ' + location.href, 12);
        let newUrl = location.href;

        let append = function(items){
            console.log('append begin '+items);
            let oldUrl = localStorage.getItem('last-page # ' + location.href);
            if( oldUrl !== newUrl){
                console.log('new url - need clean old array '+oldUrl+' '+newUrl);
                filtred = [];
                return;
            }
            // $('.load-all-wrapper').trigger('visible');

            items = items || 12; // сколько товаров добавлять при скроллинге
            if(items>filtred.length){
                items = filtred.length;
            }

            for(let i=0;i<filtred.length;i++){
                if(filtred[i].ware_type===2){
                    filtred[i].divclass='hidden'; // для колготок прячем размеры в каталоге
                }
            }
            if(filtred.length==0){
                return;
            }

            console.log('было товаров: '+filtred.length);
            $('.product-cart-list').append( Template('product-cart', filtred.splice(0, items)) );
            console.log('осталось отобразить товаров: '+filtred.length+' удалили '+items);

            // прячем футер если не все элементы подгружены
            // Александр сказал не надо прятать тк поисковики не видят футер
            // if(filtred.length==0){
            //     $('.footer-box').hide().slideDown();
            //     setTimeout(function(){
            //         $('.banner-bottom-cart-wrapper').hide().fadeIn(3000);
            //     },2000);
            //
            // }else{
            //     $('.footer-box').hide();
            //     $('.banner-bottom-cart-wrapper').hide();
            // }

            $('.product-cart-list .fade-in-hidden').removeClass('fade-in-hidden');
            let offset = 0;
            $('.product-cart-list .product-image:not(.init)').each(function () {
                let src = $(this).data('img');
                let i = new Image();
                $(this).attr('data-src', src).addClass('init').addClass('hide');
                i.onload = function() {
                    setTimeout(function () {
                        $('.product-image[data-src="'+src+'"]')
                            .css({ backgroundImage: 'url("'+src+'")' })
                            .removeClass('hide');
                        //$('.product-image[data-src="'+src+'"]').hide().fadeIn();
                    }, 10);
                };
                setTimeout(function () {
                    i.src = src;
                }, offset);
                offset += 100;
            });
            if (filtred.length == 0) {
                console.log('load-all-wrapper remove ');
                $('.load-all-wrapper').remove();
            }

            if (items > 12) window.scrollTo(0, localStorage.getItem('items-scroll') || 0);

            console.log('append end '+items);

            return $('.product-cart-list > *').length;
        };

        if (filtred.length == 0) {
            console.log('display 1 ');
            $('.results-items').html( Template('not-found') );
        } else {
            console.log('display 2 ');
            $('.results-items').html( Template('product-list') );
            //$('.load-all-wrapper').trigger('visible');

            //setInterval(showNextItems,5000);

            function showNextItems() {
                console.log('display next items ');
                if (loading) return ;
                loading = true;
                //console.log('hide footer');
                let that = $('.load-all-wrapper');
                that.addClass('spin-on');
                setTimeout(function () {
                    console.log('display 4 '+filtred.length);
                    //console.log('show footer');
                    that.removeClass('spin-on');
                    let total = append();
                    localStorage.setItem('items-on-page # ' + location.href, total);

                    loading = false;
                    //setLeftBanner(); // отобразим уехавший плавающий левый баннер
                }, 500);
            }

            // $('.load-all-wrapper').on('visible', function () {
            //     console.log('load-all-wrapper on visible ');
            //     showNextItems();
            // });

            setInterval(checkIsNeedShowNextItems,200);

            function checkIsNeedShowNextItems() {
                if($('.load-all-wrapper').html()=='.'){
                    //$('.load-all-wrapper').html('...');
                }else{
                    //$('.load-all-wrapper').html('.');
                }
                let el = $('.load-all-wrapper');
                if(isVisibleOnScreen(el)){
                    showNextItems();
                }
            }

            // функция проверки полной видимости элемента
            function isVisibleOnScreen(el){
                // координаты дива
                var div_position = $(el).offset();
                if(!div_position){
                    $('.load-all-wrapper').html('false');
                    return false;
                }
                // отступ сверху
                var div_top = div_position.top;
                // отступ слева
                var div_left = div_position.left;
                // ширина
                var div_width = $(el).width();
                // высота
                var div_height = $(el).height();

                // проскроллено сверху
                var top_scroll = $(document).scrollTop();
                // проскроллено слева
                var left_scroll = $(document).scrollLeft();
                // ширина видимой страницы
                var screen_width = $(window).width();
                // высота видимой страницы
                // var screen_height = $(window).height(); // криво на андроидах и т.п.
                var screen_height = window.innerHeight;

                // координаты углов видимой области
                var see_x1 = left_scroll;
                var see_x2 = screen_width + left_scroll;
                var see_y1 = top_scroll;
                var see_y2 = screen_height + top_scroll;

                // координаты углов искомого элемента
                var div_x1 = div_left;
                var div_x2 = div_left + div_width;
                var div_y1 = div_top;
                var div_y2 = div_top + div_height;

                // проверка - виден див полностью или нет
                if( div_x1 >= see_x1 && div_x2 <= see_x2 && div_y1 >= see_y1 && div_y2 <= see_y2 ){
                    //$('.load-all-wrapper').html('visible');
                    //console.log('element visible');
                    return true;
                }else{
                    //$('.load-all-wrapper').html(JSON.stringify({div_y1,see_y1,div_y2,see_y2}));
                }
                //console.log('not visible '+div_x1+' '+see_x1 +' '+ div_x2 +' '+ see_x2 +' '+ div_y1 +' '+ see_y1 +' '+ div_y2 +' '+ see_y2)
                return false;
            }

            append(localStorage.getItem('items-on-page # ' + location.href) || 12);
        }
    }

    $(window).on('scroll', function () {
        localStorage.setItem('items-scroll', $(window).scrollTop());
        let e = $('.load-all-wrapper');
        if (!e || !e.offset()) return;
        if (e.offset().top + 200 <= $(window).scrollTop() + $(window).height()) {
            //console.log(' + visible');
        }
    });

    // Arrays intersect is not null
    function common(a, b) {
        for (let i in a) {
            if (b.indexOf(a[i]) != -1) return true;
        }
        return false;
    }

    /* ------------------------------------------------------------ */
    /*
    e.m_top.map((e) => { if (m_top.indexOf(e.name) === -1) m_top.push(e.name); });
    e.m_sole.map((e) => { if (m_sole.indexOf(e.name) === -1) m_sole.push(e.name); });

    // [+] Materials
    $('[data-checkbox="material_top"]').html(Template('material-item', m_top));
    $('[data-checkbox="material_sole"]').html(Template('material-item', m_sole));
    */

    // Price range
    $('[data-range]').each(function () {
        let f = $(this).find('[data-from]');
        let t = $(this).find('[data-to]');

        let c_left = $(this).find('.circle.from');
        let c_right = $(this).find('.circle.to');
        let colored = $(this).find('.colored');

        let full = $(this).width() - 3;
        let value = {left: 0, right: full};
        let element, start, x, min, max;

        let scale = (t.val() - f.val()) / full;

        c_left.on('mousedown', function (e) {
            x = e.clientX;
            element = c_left;
            start = parseInt(element.css('left'));
            min = 0;
            max = value.right;
        });

        c_right.on('mousedown', function (e) {
            x = e.clientX;
            element = c_right;
            start = parseInt(element.css('left'));
            min = value.left;
            max = full;
        }).css({'left': full});

        $(document).on('mousemove', function (e) {
            if (!element) return ;
            let left = e.clientX - x + start;

            if (left < min) left = min;
            if (left > max) left = max;

            element.css({ 'left' : left });

            value.left = parseInt(c_left.css('left'));
            value.right = parseInt(c_right.css('left'));
            colored.css({'left' : value.left, 'width' : value.right - value.left});
            f.val(Math.round(scale * value.left));
            t.val(Math.round(scale * value.right));
        });

        $(this).find('[data-from], [data-to]').on('change', function () {
            if (f.val() < 0) f.val(0);
            if (t.val() > t.attr('max')) t.val(t.attr('max'));

            let xl = parseInt(f.val())/scale, xr = parseInt(t.val())/scale;
            if (xl > xr) xr = xl;

            c_left.css('left', xl);
            c_right.css('left', xr);
            colored.css({'left' : xl, 'width' : xr - xl});

            $(document).trigger('range-changed');
        });

        $(document).on('mouseup', function () {
            if (element) $(document).trigger('range-changed');
            element = false;
        });
    });
});

setTimeout(F, 550); // Debug mode
